<template>
  <div>
    <BreadcrumbsWithShareAccordion :breadcrumbs="breadcrumbs" />
    <section class="pt-8 pb-24 md:pt-20 md:pb-32">
      <div class="container">
        <div class="mb-24 lg:mb-0 max-w-400">
          <h1 class="lg:block font-light text-2xl md:text-4xl mb-8 md:mb-20">
            Modello di Organizzazione D.Lgs. 231/2001
          </h1>
          <p class="mb-12 font-bold uppercase">
            organismo di vigilanza ("odv") ai sensi del d.lgs 231/2001
          </p>
          <p class="mb-4">
            Il D. Lgs. 231/01 prevede l'istituzione di un Organismo di Vigilanza
            interno all'Ente (di seguito anche OdV), dotato di autonomi poteri
            di iniziativa e di controllo, cui è assegnato specificamente il
            compito di vigilare sul funzionamento e l'osservanza del modello di
            organizzazione e di gestione e di curarne il relativo aggiornamento.
          </p>
          <p class="mb-4">
            Le funzione di OdV di UniCredit RE Services S.p.A. sono attribuite
            al Collegio Sindacale della Società, composto da 3 membri, ai sensi
            di quanto previsto dall’art. 6 comma 4 bis del D.lgs. 231/2001.
          </p>
          <p class="mb-4">
            In proposito, l’art. 2409 del Codice Civile stabilisce che l’Organo
            Sindacale vigili sull’adeguatezza dell’assetto organizzativo,
            amministrativo e contabile adottato dalla Società, di cui il Modello
            Organizzativo 231 costituisce parte integrante; il Collegio
            Sindacale, quindi, già ricopre un ruolo centrale nel Sistema dei
            Controlli interni della Società.
          </p>
          <p class="mb-4">
            L'OdV è istituito con delibera del Consiglio di Amministrazione che,
            in sede di nomina, deve dare atto della valutazione della
            sussistenza dei requisiti di indipendenza, autonomia, onorabilità e
            professionalità dei suoi membri.
          </p>
          <p class="mb-4">
            La durata in carica dei membri dell'OdV coincide con quella del
            Consiglio di Amministrazione che l'ha nominato e i suoi membri
            possono essere rieletti.
          </p>
          <p class="mb-4">
            La rinuncia da parte dei componenti dell'OdV può essere esercitata
            in qualsiasi momento e deve essere comunicata al Consiglio di
            Amministrazione per iscritto unitamente alle motivazioni che l'hanno
            determinata.
          </p>
          <p class="mb-12">
            La descrizione di dettaglio dei comiti e del funzionamento dell'OdV
            è contenuta nel Modello di Organizzazione e Gestione di UniCredit
            S.p.A. approvato dal Consiglio di Amministrazione
          </p>
          <p class="mb-12 font-bold uppercase">
            modello di organizzazione e gestione ai sensi del d.lgs 231/2001
          </p>
          <p class="mb-4">
            Il decreto legislativo n. 231, dell'8 giugno 2001, disciplina la
            responsabilità amministrativa delle persone giuridiche, delle
            società e delle associazioni anche prive di personalità giuridica
            (enti). Tale forma di responsabilità presenta forti analogie con
            quella penale poiché è autonoma rispetto alla persona fisica che ha
            commesso il reato (l'ente potrà essere dichiarato responsabile anche
            se la persona fisica che ha commesso il reato non è perseguibile
            ovvero non è stata individuata).
          </p>
          <p class="mb-4">
            L'ente può incorrere in tale responsabilità qualora:
          </p>
          <p class="mb-4">
            a) un soggetto che riveste posizione apicale al suo interno , ovvero
            un sottoposto, abbia commesso uno dei reati previsti dalla parte
            speciale del Decreto;<br aria-hidden="true" />
            b) il reato sia stato commesso nell'interesse o a vantaggio
            dell'ente stesso e sia espressione della politica aziendale o
            quantomeno derivi da una colpa da organizzazione.
          </p>
          <p class="mb-4">
            L'ente può essere esonerato dalla responsabilità se dimostra di aver
            adottato ed efficacemente attuato modelli di organizzazione e di
            gestione idonei a prevenire la commissione degli illeciti previsti
            dal decreto.
          </p>
          <p class="mb-4">
            In tale contesto UniCredit RE Services S.p.A. ha adottato un proprio
            Modello di Organizzazione e Gestione che descrive la metodologia
            adottata per il presidio dei rischi ex D.Lgs 231/2001, la
            composizione e il ruolo dell'Organismo di Vigilanza e il sistema
            disciplinare interno.
          </p>
          <p class="mb-20">
            Il "Codice Etico ai sensi del D.Lgs. 231/2001" costituisce parte
            integrante del Modello di Organizzazione e Gestione e contiene le
            regole volte a garantire che i comportamenti dei soggetti
            destinatari siano sempre ispirati a criteri di correttezza,
            collaborazione, lealtà, trasparenza e reciproco rispetto, nonché ad
            evitare che vengano poste in essere condotte idonee ad integrare le
            fattispecie di reato e illeciti amministrativi inclusi nell'elenco
            del D.Lgs. 231/01.
          </p>
          <UcrsAnchor
            to="/assets/pdf/modello-di-organizzazione-e-gestione-231.pdf"
            target="_blank"
            label="Modello di organizzazione e gestione di UniCredit RE Services S.p.A. ai sensi del D.LGS. 231/01 (220kb)"
            icon="download"
            icon-position="left"
            icon-size="md"
            class="mb-20"
          />
          <UcrsAnchor
            to="/assets/pdf/codice-etico.pdf"
            target="_blank"
            label="Codice Etico ai sensi del D.Lgs. 231/2001 (162kb)"
            icon="download"
            icon-position="left"
            icon-size="md"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Components
import BreadcrumbsWithShareAccordion from '~/components/BreadcrumbsWithShareAccordion.vue'
import UcrsAnchor from '~/components/UcrsAnchor.vue'

export default {
  components: { BreadcrumbsWithShareAccordion, UcrsAnchor },
  async asyncData({ route, $axios }) {
    let meta
    await $axios
      .get('/_api/api/v1/meta', {
        params: {
          slug: route.path,
        },
      })
      .then((res) => {
        meta = res.data.data
      })
      .catch(() => {
        meta = {
          title: 'Modelloorganizzazione - UniCredit RE Services',
          description: 'Modelloorganizzazione - UniCredit RE Services',
        }
      })
    return { meta }
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$store.state.auth.loggedIn ? 'La mia homepage' : 'Home',
          href: '/',
        },
        {
          text: 'Modello di Organizzazione D.Lgs. 231/2001',
        },
      ],
    }
  },
  head() {
    return {
      title: this.meta.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.meta.description,
        },
      ],
    }
  },
}
</script>
